import React from 'react'
import { Container, Row, Col } from "reactstrap";
import TableActivities from './TableActivities'
import SelectDateTime from '../../components/SelectDateTime'
import SelectFilterClear from '../../components/SelectFilterClear'
import InputSelect from '../../components/InputSelect'

export default function Activities() {

    return (
        <Container fluid>
            <Row>
                <Col xs={12} sm={12} md={6} lg={6} xl={3}>
                <SelectDateTime headerComponents="Date from" />
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={3}>
                <SelectDateTime headerComponents="Date to" />
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={3}>
                <SelectFilterClear 
                headerSelectFilterClear="Device"
                />
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={3}>
                <InputSelect />
                </Col>
            </Row>
            <br />
            <Row>
                <Col>
                <TableActivities />
                </Col>
            </Row>
        </Container>
    )
}
